import { render, staticRenderFns } from "./index.vue?vue&type=template&id=afcdb1c8&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=afcdb1c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports